import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ValueProps } from './components/ValueProps';
import { Included } from './components/Included';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ValueProps data-id="element-4" />
        <Included data-id="element-5" />
        <Pricing data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}